// nodes/databaseNode.js
import { BaseNode } from "../baseNode";
import { nodeConfigs } from "../nodeConfigs";

export const DatabaseNode = ({ id, data }) => (
  <BaseNode id={id} data={data} config={nodeConfigs.database} />
);
